export default class ErrorSummaryParser {
  public readonly errorText: string;

  constructor(runReport: any) {
    this.errorText = runReport.errorText;
    if (this.errorText == null) throw Error('Missing error text');
  }
}
